
import axios from "axios";

const api = axios.create({
  baseURL: "https://contable.alerama.cl/public/api"
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("Token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});


export default api;

/* "http://127.0.0.1:8000/api"  */
/* "https://contable.alerama.cl/public/api" */
